import { ref } from 'vue';
import apiClient from '@/api/apiClient';
import Swal from 'sweetalert2';

export function useUpload() {
  const isUploading = ref(false);
  const uploadProgress = ref(0); // Por si quieres poner una barra de carga pro

  /**
   * Sube un archivo al servidor
   * @param {File} file - El objeto archivo (de un input type="file" o dropzone)
   * @returns {Promise<string|null>} - Retorna la ruta del archivo o null si falla
   */
  const uploadFile = async (file) => {
    if (!file) return null;

    isUploading.value = true;
    uploadProgress.value = 0;

    const formData = new FormData();
    formData.append('image', file); // El backend espera 'image' según tu case

    try {
      const response = await apiClient.post('/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        // Bonus: Tracking de progreso
        onUploadProgress: (progressEvent) => {
          uploadProgress.value = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        },
      });

      // Asumiendo que tu backend retorna { success: true, file_path: 'uploads/xyz.jpg' }
      if (response.data && response.data.file_path) {
        return response.data.file_path;
      } else {
        throw new Error("Respuesta de servidor inválida");
      }
    } catch (error) {
      const msg = error.response?.data?.error || "Error al subir el archivo";
      Swal.fire({
              icon: 'error',
              title: 'Error de subida',
              text: msg,
              confirmButtonColor: '#ec4899'
            });
      return null;
    } finally {
      isUploading.value = false;
    }
  };

  return {
    uploadFile,
    isUploading,
    uploadProgress
  };
}